export const clearStorage = () => {
  sessionStorage.removeItem("rit-cart_id");
  sessionStorage.removeItem("rit-marketing_preference");
  sessionStorage.removeItem("rit-purchased_cart");
  sessionStorage.removeItem("rit-purchased_cart_products");
  sessionStorage.removeItem("rit-order_number");
  sessionStorage.removeItem("rit-reset_password_token");
  sessionStorage.removeItem("rit-express_checkout_confirm_event");
  sessionStorage.removeItem("rit-payment_intent_client_secret");
  sessionStorage.removeItem("rit-subscription_id");
  sessionStorage.removeItem("rit-applied_product_promotion_product");
};
